import { size } from "lodash";
import { useLocation } from "react-router-dom";
import { useSessionStore } from "../../../../../store/useSessionStore";
import { ChatBotWidget } from "../ChatBotWidget";
import { WidgetCol, WidgetsWrapper } from "./style";

type Props = { manualSubmit: (messageValue: string) => Promise<void> };

const WidgetsComp = ({ manualSubmit }: Props) => {
  const messages = useSessionStore.use.messages();
  const { state: locationState } = useLocation();
  const externalState = locationState as { brightbotText?: string };

  return (
    <>
      {size(messages) < 1 && !externalState && (
        <WidgetsWrapper>
          <WidgetCol>
            <ChatBotWidget
              title="Draft a data strategy"
              description="Look at the documents provided in the workspace and write a data strategy document for me."
              onClick={() =>
                manualSubmit(
                  "Look at the documents provided in the workspace and write a data strategy document for me."
                )
              }
            />
          </WidgetCol>
          <WidgetCol>
            <ChatBotWidget
              title="Extract information for docs"
              description="Take the document that I upload and extract key terms based on the category of teams that I specify."
              onClick={() =>
                manualSubmit(
                  "Take the document that I upload and extract key terms based on the category of teams that I specify."
                )
              }
            />
          </WidgetCol>
          <WidgetCol>
            <ChatBotWidget
              title="Quick insights from my data"
              description="Look at my most recently used data asset and tell me some interesting and novel insights."
              onClick={() =>
                manualSubmit(
                  "Look at my most recently used data asset and tell me some interesting and novel insights."
                )
              }
            />
          </WidgetCol>
        </WidgetsWrapper>
      )}
    </>
  );
};

export default WidgetsComp;
